/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Member_Login_Methods_Save_ErrorInputs */



/**
* | output |
* | --- |
* | "Could not update the sign-in methods." |
*
* @param {Member_Login_Methods_Save_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const member_login_methods_save_error = /** @type {((inputs?: Member_Login_Methods_Save_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Member_Login_Methods_Save_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Anmeldemethoden konnten nicht aktualisiert werden.")
	return /** @type {LocalizedString} */ ("Could not update the sign-in methods.")
});